export const closeClientEboxViewer = viewer => ({
  type: "CLOSE_CLIENT_EBOX_VIEWER",
  viewer
});

export const openClientEboxViewer = viewer => ({
  type: "OPEN_CLIENT_EBOX_VIEWER",
  viewer
});



// WEBPACK FOOTER //
// ./src/actions/actions/client-ebox-viewer.js